<div class="container ">
    <div class="closebutton pointer">
        <img (click)="closeDialog();">
    </div>
    <div>
        <h3>Choose Your Membership Plan</h3>
        <p style="color:#6c757d">Get access to exclusive opportunities with Songdew Pro</p>
    </div>
    <div class="box">
        <div class=" pt-5 col-lg-5 col-md-4 pr-md-3" *ngIf="!global.isMobile()">
            <div class="img-box">
                <!-- <img class="img-fluid" src="../../../assets/subscription/person.svg" alt="person" *ngIf="!selected"> -->
                <img class="img-fluid" src="../../../assets/subscription/prouser.svg" alt="properson" *ngIf="selected">
            </div>


        </div>
        <div class="col">
            <table>
                <th></th>
                <!-- <th [ngClass]="{'highlight':!selected}" class="text-center">
                    <p></p>Free
                </th> -->
                <th [ngClass]="{'highlight':selected}" class="text-center"> <img class="pro-crown ml-2"
                        src="../../../../assets/subscription/yellow-crown.svg" width="18px"> Pro</th>
                <tbody>
                    <tr>
                        <td>Upload Unlimited Tracks
                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Distribute Unlimited Tracks
                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}"></td>
                         -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Basic Opportunities

                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Exclusive Opportunities

                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}"></td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Basic Tools: Social Media Banners, Press Release, etc.

                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Customizable Tools: Social Cards, AI Generated Press Release, Pre Save Links

                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}">
                        </td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Pitching Tools: Pitch for Radio Playouts to 11 stations, Promotion on TV, etc.

                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}">
                        </td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                    <tr>
                        <td>Personalized e-Press Kit

                        </td>
                        <!-- <td [ngClass]="{'highlight':!selected}"><img src="../../../assets/images/tick.svg"
                            alt="true">
                        </td> -->
                        <td [ngClass]="{'highlight':selected}"><img src="../../../assets/images/tick.svg" alt="true">
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3">
                <!-- <div class="option-box mr-2 ml-auto" (click)="choosePlan('Free')"
                    [ngClass]="{'highlight-box':!selected}">
                    <span class="selected-badge" *ngIf="!selected"></span>
                    <h5>Free</h5>
                    <span>Rs.&nbsp; 0/Year </span>

                </div> -->
                <div class="option-box ml-auto" (click)="choosePlan('pro')" [ngClass]="{'highlight-box':selected}">
                    <span class="selected-badge" *ngIf="selected"></span>


                    <h5>Pro </h5>
                    <span class="strike">Rs.&nbsp; 4000/Year </span>
                    <span class="">Rs.&nbsp; 2000/Year </span>

                </div>
            </div>


                <button class="mt-3"  [routerLink]="user.isProMember==2 ?'/subscription/songdew-pro': '/subscription/checkout'" (click)="closeDialog()">
                    {{ user.isProMember==2? 'Renew your account >':'Continue with Pro >'}}
                </button>
        </div>


    </div>










</div>
